import React, { useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function FuelStash() {
    const authState = useSelector((state) => state.authReducer || {});
    const navigate = useNavigate();

    const user = authState?.user || {};
    const userCode = user?.think5whyscode || "";
    const userName = user?.name || "User";

    const goBackRoute = "/purpledoor"

    const actions = useMemo(
        () => [
            {
                title: "💼 My FuelStash",
                description: "View balance, transactions and activity.",
                to: "/wallet-mywallet",
                color: "border-cyan-400/30",
                disabled: false,
            },
            {
                title: "➕ FuelStash Topup",
                description: "Add fuel to your stash for payments.",
                to: "/wallet-topup",
                color: "border-green-400/30",
                disabled: true,
            },
            {
                title: "🔄 FuelStash Exchange",
                description: "Transfer FuelStash between users.",
                to: "/wallet-transfer",
                color: "border-blue-400/30",
                disabled: false,
            },
            {
                title: "🏦 Bank Credits",
                description: "Track direct bank / UPI payments.",
                to: "/wallet-mywallettemp",
                color: "border-emerald-400/30",
                disabled: true,
            },
            {
                title: "🎟️ FuelStash Credits",
                description: "Redeem promo and reward-based credits.",
                to: "",
                color: "border-violet-400/30",
                disabled: true,
            },
        ],
        []
    );

    const goBack = () => {
        navigate(-1);
    };

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-950 via-gray-900 to-gray-950 text-white px-3 py-4 space-y-4">
            <div className="relative overflow-hidden rounded-xl border border-gray-800 bg-gray-900 p-4">
                <div className="absolute inset-0 opacity-20 bg-gradient-to-r from-cyan-500 via-blue-500 to-purple-500 blur-2xl"></div>
                <div className="relative flex items-center justify-between">
                    <div>
                        <h2 className="text-cyan-300 font-bold text-sm">
                            ⚡ FuelStash Hub
                        </h2>
                        <p className="text-xs text-gray-300 mt-1">
                            Store • Move • Grow your digital fuel
                        </p>
                    </div>
                    <div className="text-right text-xs text-gray-300">
                        <div className="text-gray-400">Welcome</div>
                        <div className="text-cyan-200 font-semibold">
                            {userName}{" "}
                            <span className="text-gray-400">{userCode}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="px-2 mb-3">
                <button
                    onClick={() => goBack()}
                    className="
                        group
                        flex items-center gap-2
                        text-xs lg:text-sm
                        w-fit
                        px-2 py-1
                        rounded-full
                        bg-white/5
                        border border-white/10
                        text-gray-300
                        hover:text-white
                        hover:bg-white/10
                        hover:border-cyan-400/40
                        transition-all duration-200
                        backdrop-blur-md
                    "
                >
                    <span className="text-lg group-hover:-translate-x-1 transition">
                        ←
                    </span>
                    <span>Back</span>
                </button>
            </div>

            <div className="space-y-1 mt-2">
                {actions.map((action) =>
                    action.disabled ? (
                        <div
                            key={action.to}
                            className={`relative rounded-xl border ${action.color} bg-gray-900/60 p-4 pl-6 opacity-50 cursor-not-allowed`}
                        >
                            <div className="flex justify-between border-l-4 border-cyan-200 rounded-xl px-2">
                                <div>
                                    <div className="text-sm font-semibold text-gray-100">
                                        {action.title}
                                    </div>
                                    <div className="text-[11px] text-gray-200 mt-1">
                                        {action.description}
                                    </div>
                                </div>
                                <div className="text-gray-500">→</div>
                            </div>
                        </div>
                    ) : (
                        <Link
                            key={action.to}
                            to={action.to}
                            className={`relative group rounded-xl border ${action.color} bg-gray-900/70 p-4 pl-6 transition-all duration-200 hover:bg-gray-800 hover:scale-[1.01] hover:shadow-lg hover:shadow-cyan-500/10`}
                        >
                            <div className="flex justify-between border-l-4 border-cyan-200 rounded-xl px-2">
                                <div>
                                    <div className="text-sm font-semibold text-white group-hover:text-cyan-200">
                                        {action.title}
                                    </div>
                                    <div className="text-[11px] text-gray-200 mt-1">
                                        {action.description}
                                    </div>
                                </div>
                                <div className="text-cyan-400 text-xl group-hover:translate-x-1 transition">
                                    ➤
                                </div>
                            </div>
                        </Link>
                    )
                )}
            </div>

            <div className="rounded-xl border border-gray-800 bg-gray-900 p-3 text-center">
                <div className="text-[11px] text-gray-400">
                    ⚡ Think5Whys FuelStash • Simple. Fast. Transparent. Global.
                </div>
            </div>
        </div>
    );
}